import { WeekMenu } from "src/types/ApiItems";
import { FetchApi } from "./FetchApi";

export class MenuApi extends FetchApi {
  getWeekMenu() {
    return this.get<WeekMenu[]>("/menus/byday");
  }
}
